/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface OTPViaSMSMethodOptions
 */
export interface OTPViaSMSMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof OTPViaSMSMethodOptions
     */
    method: FactorMethod;
}



/**
 * Check if a given object implements the OTPViaSMSMethodOptions interface.
 */
export function instanceOfOTPViaSMSMethodOptions(value: object): value is OTPViaSMSMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function OTPViaSMSMethodOptionsFromJSON(json: any): OTPViaSMSMethodOptions {
    return OTPViaSMSMethodOptionsFromJSONTyped(json, false);
}

export function OTPViaSMSMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPViaSMSMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function OTPViaSMSMethodOptionsToJSON(json: any): OTPViaSMSMethodOptions {
    return OTPViaSMSMethodOptionsToJSONTyped(json, false);
}

export function OTPViaSMSMethodOptionsToJSONTyped(value?: OTPViaSMSMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
    };
}

